import React from "react";
import { Link } from "react-router-dom";
import siteContent from "../../../generated/site-content";

function NotFoundPage() {
  return (
    <section className="w-full max-w-4xl py-4">
      <p className="theme-text-muted text-[0.65rem] font-semibold uppercase tracking-[0.28em] sm:text-xs">
        {siteContent.pages.notFound.eyebrow}
      </p>
      <h1 className="theme-text mt-3 text-3xl font-semibold tracking-tight sm:text-4xl">
        {siteContent.pages.notFound.title}
      </h1>
      <p className="theme-text-muted mt-4 max-w-2xl text-sm leading-7 sm:text-base">
        {siteContent.pages.notFound.description}
      </p>
      <Link to="/" className="theme-link mt-6 inline-flex text-sm font-medium">
        {siteContent.pages.notFound.backHomeLabel}
      </Link>
    </section>
  );
}

export default NotFoundPage;
